<template>
  <div class="order-item-container">
    <div class="top">
      <div class="left">
          {{item.ordersn}}
      </div>
      <div class="right">
        <span class="pay-price" v-bind:class="{ red: item.operationType == 2 }">{{item.amount}}</span>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <span class="pay-time">{{item.createDate}}</span>
        <span class="bz" v-if="item.bizType==67"> 推荐奖励</span>
        <span class="bz" v-if="item.bizType==87"> 奖励取消</span>
      </div>
      <div class="right">
        {{item.rstatus==0?'未入账':item.rstatus==1?'已入账':''}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderItem",
  props: {
    item:null
  },
  computed: {
    // 计算属性的 getter
    payTypeName: function () {
      let name
      if (this.payType == 0) {
        name = '扫码收银'
      }else if(this.payType == 1){
        name = '门店订单'
      }
      return name
    }
  }
};
</script>

<style lang="scss">
.order-item-container{
  display: flex;
  flex-direction: column;
  margin: 1rem 0.5rem 0 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  box-shadow: 2px 2px 5px #dedede;
  .top{
    display:flex;
    justify-content: space-between;
    align-items: center;
    color: #333333;
    font-size: 1rem;
    .right{
      font-size: 1rem;
      font-weight: bold;
      .pay-price.red{
        color: #ff3366;
      }
    }
  }
  .bottom{
    font-size: 1rem;
    display: flex;
    justify-content: space-between;
  }
}
</style>
